import aqilaApi from './aqila-api';

export type AlertaClassificacao = {
  tipo: string;
  gleba: number;
  classificacoes: string[];
  atividades: number[];
  hint: string[];
  cultivares: {
    id: number;
    estimada: string;
    ideal: string | null;
    variacao: number;
  }[];
};

export type TalhaoEstadio = {
  safra: { id: number };
  plantio: { inicio: string; fim: string };
  atividade: { id: number; descricao: string };
  estadio: { id: number; descricao: string; abreviatura: string };
};

export type TalhaoAlerta = {
  id: number;
  areaTotal: string;
  descricao: string;
  ultimaAcao: string;
  ultimaPulverizacao: number;
  diasDesdeAUltimaAcao: number;
  estadios: TalhaoEstadio[] | null;
  neutro: AlertaClassificacao[];
  equilibrio: AlertaClassificacao[];
  controle: AlertaClassificacao[];
  alerta: AlertaClassificacao[];
};

class AlertasTalhao {
  async byPropriedade(propriedadeId: number): Promise<TalhaoAlerta[]> {
    const { data } = await aqilaApi.get<TalhaoAlerta[]>(
      'v1/operacoes_campo/alertas',
      { params: { propriedade: propriedadeId } },
    );
    return data;
  }
}

export default new AlertasTalhao();
